import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import { InputProperty } from "../interfaces/generalInterface";


interface IMultiSelectLabel extends InputProperty {
    options: any;
    dropdownGap?: number;
    values?: any;
    dropdownPosition: any;
    onChange?: (value: any) => void;
    searchable?: boolean;
    disabled?: boolean;
    hasSelectAll?: boolean;
    labelAllSelected?: string;
    placeholder?: string;
}


const CWMultiSelect = (props: IMultiSelectLabel) => {
    const onChange = (e: any) => {
        if (props.onChange) props.onChange(e);
    };

    return (
        <div className="form-group cw-select">
            <div className={"custom-select-wrap" + " " + props.className}>
                <div className="label-wrap">
                    <label>
                        {props.label}
                        {props.isMandatory && <span className="mandatory">*</span>}
                    </label>
                    <span>{props.help}</span>
                </div>

                <MultiSelect
                    options={props.options}
                    value={props.value}
                    onChange={onChange}
                    labelledBy="Select"
                    hasSelectAll={props.hasSelectAll}
                    disabled={props.disabled}
                    overrideStrings={{ "allItemsAreSelected": props.labelAllSelected ? props.labelAllSelected : "All items Selected.", "selectSomeItems": props.placeholder ? props.placeholder : '', }} />
                {props.errorMessage && props.errorMessage !== "" && <span className="error-msg">{props.errorMessage}</span>}

            </div>
        </div>
    );
};

export default CWMultiSelect;